export default __webpack_public_path__ + "static/media/Steelspirirt Legguards.6c007218.jpg";